/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Open_Mail_FailedInputs */

const en_password_reset_open_mail_failed = /** @type {(inputs: Password_Reset_Open_Mail_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't open your mail app. Open it yourself to find the link.`)
};

const es_password_reset_open_mail_failed = /** @type {(inputs: Password_Reset_Open_Mail_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos abrir tu app de correo. Ábrela tú para encontrar el enlace.`)
};

/**
* | output |
* | --- |
* | "We couldn't open your mail app. Open it yourself to find the link." |
*
* @param {Password_Reset_Open_Mail_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_open_mail_failed = /** @type {((inputs?: Password_Reset_Open_Mail_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Open_Mail_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_open_mail_failed(inputs)
	return en_password_reset_open_mail_failed(inputs)
});